import { BUSINESS } from "@/App";
import { Phone, Mail, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-ink text-white/80 pt-16 pb-10 mt-6" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <div className="h-9 w-9 rounded-xl bg-orange-500 grid place-items-center text-white font-display font-black">
                B
              </div>
              <div className="font-display font-extrabold text-white text-lg">
                {BUSINESS.name}
              </div>
            </div>
            <p className="mt-4 max-w-md text-sm text-white/60">
              Bangalore&apos;s most trusted residential painting crew. Premium paints,
              skilled craft, transparent prices.
            </p>
          </div>
          <div>
            <div className="text-[11px] uppercase tracking-widest font-bold text-orange-300">
              Services
            </div>
            <ul className="mt-4 space-y-2 text-sm">
              {["Interior Repainting", "Exterior Repainting", "Full Home Repaint", "Accent Wall Refresh", "Damp-Patch Repainting"].map(
                (s) => (
                  <li key={s}>
                    <a href="#services" className="hover:text-white transition-colors">
                      {s}
                    </a>
                  </li>
                )
              )}
            </ul>
          </div>
          <div>
            <div className="text-[11px] uppercase tracking-widest font-bold text-orange-300">
              Reach us
            </div>
            <ul className="mt-4 space-y-3 text-sm">
              <li className="flex items-center gap-2">
                <Phone className="h-4 w-4 text-orange-300" /> {BUSINESS.phone}
              </li>
              <li className="flex items-center gap-2">
                <Mail className="h-4 w-4 text-orange-300" /> {BUSINESS.email}
              </li>
              <li className="flex items-center gap-2">
                <MapPin className="h-4 w-4 text-orange-300" /> {BUSINESS.area}
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-12 pt-6 border-t border-white/10 flex flex-wrap items-center justify-between gap-3 text-xs text-white/50">
          <div>© {new Date().getFullYear()} {BUSINESS.name}. All rights reserved.</div>
          <div className="flex gap-5">
            <a href="/admin" className="hover:text-white">Admin</a>
            <a href="#contact" className="hover:text-white">Contact</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
